// This is just an example,
// so you can safely delete all default props below
import strings from './de-de.json';
export default strings;
